import clsx from 'clsx';
import { FC, ReactNode } from 'react';
import { default as ReactModal } from 'react-modal';

import { CloseIcon } from 'shared/icons';
import styles from './Modal.module.scss';

export type ModalVariant = 'modal' | 'inline';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    className?: string;
    shouldFocusAfterRender?: boolean;
    variant?: ModalVariant;
    showCloseButton?: boolean;
    children?: ReactNode;
};

const Modal: FC<Props> = ({
    children,
    isOpen,
    onClose,
    className,
    shouldFocusAfterRender = true,
    variant = 'modal',
    showCloseButton = true,
}) => {
    if (variant === 'inline') {
        if (!isOpen) {
            return null;
        }

        return (
            <div className={clsx(styles.InlinePanel, className)}>
                {onClose && showCloseButton && (
                    <div className={styles.ModalHeader}>
                        <CloseIcon
                            onClick={onClose}
                            className={styles.CloseIcon}
                        />
                    </div>
                )}
                {children}
            </div>
        );
    }

    return (
        <ReactModal
            isOpen={isOpen}
            shouldCloseOnOverlayClick={false}
            onRequestClose={onClose}
            className={clsx(styles.Modal, className)}
            overlayClassName={styles.Overlay}
            shouldFocusAfterRender={shouldFocusAfterRender}
        >
            {onClose && showCloseButton && (
                <div className={styles.ModalHeader}>
                    <CloseIcon onClick={onClose} className={styles.CloseIcon} />
                </div>
            )}
            {children}
        </ReactModal>
    );
};

export default Modal;
